import { createSlice } from "@reduxjs/toolkit";

const initialAttributesState = {
  entities: [],
  totalCount: null,
  listLoading: false,
  actionsLoading: false,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const saleAttributesSlice = createSlice({
  name: "attributes",
  initialState: initialAttributesState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message.success = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // attributes fetched from api
    attributesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // attribute created
    attributeCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(entity);
      state.message.success = message;
    },
    // attribute updated
    attributeUpdated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.entities = state.entities.map((attribute) => {
        if (attribute.id === entity.id) {
          return entity;
        }
        return attribute;
      });
      state.message.success = message;
    },
    // attribute deleted
    attributeDeleted: (state, action) => {
      const { message, id } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.entities = state.entities.filter((entity) => entity.id !== Number(id));
      state.message.success = message;
    },

    successActionCompleted: (state) => {
      state.message.success = null;
    },

    errorActionCompleted: (state) => {
      state.message.error = null;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
